import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export const Header = ({ onJoin }) => {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/50 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-20 flex items-center justify-between">
        <div data-testid="wordmark-slot" aria-hidden="true" className="h-6" />
        <div className="flex items-center gap-8">
          <div className="flex items-center gap-1 text-xs tracking-[0.2em] font-sans-body">
            <button
              data-testid="lang-toggle-en"
              onClick={() => setLang("en")}
              className={`px-1 transition-colors duration-300 ${lang === "en" ? "text-[#D4AF37]" : "text-zinc-500 hover:text-zinc-300"}`}
            >
              EN
            </button>
            <span className="text-zinc-700">/</span>
            <button
              data-testid="lang-toggle-es"
              onClick={() => setLang("es")}
              className={`px-1 transition-colors duration-300 ${lang === "es" ? "text-[#D4AF37]" : "text-zinc-500 hover:text-zinc-300"}`}
            >
              ES
            </button>
          </div>
          <button
            data-testid="header-join-btn"
            onClick={onJoin}
            className="hidden md:inline-block text-xs tracking-[0.2em] uppercase font-sans-body text-[#FAFAFA] border-b border-[#D4AF37] pb-1 hover:text-[#D4AF37] transition-colors duration-300"
          >
            {t.nav.join}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
